import type { SheetInches } from "common/types/nominalNumbersTypes";
import { sheetInchesNew } from "common/utils/nominalNumbers";

export const ZERO_INCHES = sheetInchesNew(0);
export const DEFAULT_LARGE_FONT_SIZE = (1 / 4) as SheetInches;
